<template>
    <section class="app-main ">
        <div class="top-bar">
            <el-input v-model="search" class="m-width-4" @keyup.enter.native="handleSearch" placeholder="查询">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>   
            <!-- <a href="https://myadmin.moobyyoho.com/customsexcelexport" v-show="tableData.length != 0">
                <el-button type="primary" plain>表格导出</el-button>
            </a> -->
        </div>



        <!-- 商品列表 -->
        <el-card shadow="hover">
            <el-table  :data="tableData" empty-text="暂无盘点数据" height="600" style="width: 100%">
                <el-table-column prop="batch"              label="批次"       align="center"  ></el-table-column>
                <el-table-column prop="purchase_title"     label="商品名称"   align="center"  show-overflow-tooltip></el-table-column>
                <el-table-column prop="purchase_pic_url" label="商品图片"   align="center" >
                    <template slot-scope="scope">
                        <table-img :src="scope.row.purchase_pic_url"></table-img>
                    </template>
                </el-table-column>
                <el-table-column prop="barcode"            label="条形码"     align="center"  min-width="140"> </el-table-column>
                <el-table-column prop="attr_symbol_string" label="规格属性"   align="center"  >
                    <template slot-scope="scope" v-if="scope.row.attr_symbol_string">    
                        <el-tag size="medium" class="m-right-3">{{scope.row.attr_symbol_string}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="number"             label="盘点数量"   align="center"  ></el-table-column>
                <el-table-column prop="mode_data"          label="运输方式"   align="center"  ></el-table-column>
                <el-table-column prop="created_at"         label="入库时间"   align="center"  min-width="160"></el-table-column>
            </el-table>
            <el-pagination :total="total" :page-size="size" @current-change="loadMore" background layout="prev, pager, next, jumper" class="m-pagination" > </el-pagination>
        </el-card>

        


    </section>
</template>

<script>
import { canada_get, customs } from '@/api/warehouse.js'
import tableImg from '@/components/Image.vue'
export default {
    components:{ tableImg },
    data() {
        return {
            search:'',
            tableData:[],     
            total:0,     
            size:20,
        }
    },
    methods: {
        getData(){
            let params = {
                page:  this.page,
            }
            if(this.search != ""){
                params.many_search = this.search       
            }
            
            canada_get(1,params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total     = res.data.total
                    this.size      = res.data.per_page
                }else{
                    this.tableData = []
                    this.total     = 0
                }
            })
        },
        // 搜索数据
        handleSearch(){
            if(this.batch == "" || this.box == ""){
                this.$message.error("商品批次、箱号不能为空...")
                return false
            }
            this.page = 1
            this.getData()
        },
        // 页数改变时请求数据
        loadMore(page){
            this.page = page
            this.getData()
        },

        start(){
            
            if(this.batch === ""){
                this.$message.error("请完善商品批次...")
                return false
            }
            if(this.box === ""){
                this.$message.error("请完善箱号...")
                return false
            }
            if(this.barcode === ""){
                this.$message.error("请完善商品条形码...")
                return false
            }
            let params = {
                batch:this.batch,
                box:this.box,
                barcode:this.barcode,
                
            }
            customs(params).then(res => {
                if(res){
                    this.$message({type:'success', message:res.msg, duration:1500})
                    this.barcode = ""
                    this.$refs.input.focus()
                    this.getData()
                }
            })
        },
        // 盘点确认
        handleConfirm(){
            if(this.batch === ""){
                this.$message.error("请完善商品批次...")
                return false
            }
            if(this.code === ""){
                this.$message.error("请完善商品条形码...")
                return false
            }
            
        },
        del(){},
        
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>

